import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Preview from "../../../Pages/Preview/Preview";
import Login from "../../Login/Login";
import "./LoginPopup.scss";
import Signup from "../../Signup/Signup";
import Reset from "../../Reset_Password/reset";

function LoginPopup(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [active, setActive] = useState("login");

  const handleActive = (loginType) => {
    setActive(loginType);
  };

  useEffect(() => {
    if (props && props.type && props.type == "signup") {
      setActive("signup");
    } else {
      setActive("login");
    }
  }, [props.type]);

  return (
    <>
      <Modal
        show={props.show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="login-example-modal"
        keyboard={true}
        onEscapeKeyDown={props.hide}
      >
        <Modal.Body className="login-example-body">
          <img
            onClick={props.hide}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="login-popup-div">
            {active && active == "login" ? (
              <Login
                isModal={true}
                handleActive={handleActive}
                active={active}
                resumeFields={props.resumeFields}
                setResumeFields={props.setResumeFields}
              />
            ) : active == "signup" ? (
              <Signup
                isModal={true}
                handleActive={handleActive}
                active={active}
                resumeFields={props.resumeFields}
                setResumeFields={props.setResumeFields}
              />
            ) : active == "reset" ? (
              <Reset
                isModal={true}
                handleActive={handleActive}
                resumeFields={props.resumeFields}
                setResumeFields={props.setResumeFields}
              />
            ) : (
              <Login
                isModal={true}
                handleActive={handleActive}
                active={active}
                resumeFields={props.resumeFields}
                setResumeFields={props.setResumeFields}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default LoginPopup;
